import script from "./BanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BanModal.vue?vue&type=script&setup=true&lang=js"

import "./BanModal.vue?vue&type=style&index=0&id=7143d05a&lang=scss&scoped=true"
script.__scopeId = "data-v-7143d05a"

export default script